'use strict';
module.exports.get = function() {
    return $.extend(true, {}, {
        cabinClass: 'TOURIST',
        directFlightsOnly: false,
        internalSearch: true,
        numAdults: 2,
        numChildren: 0,
        numInfants: 0,
        numberOfRooms: 1,
        rooms: [
            {
                childrenAges: [],
                infantsAges: [],
                kidsAges: [],
                numAdults: 2,
            },
        ],
        searchSegments: [
            {
                dateStr: '',
                departure: {
                    city: '',
                    country: '',
                    countryCode: '',
                    geoNodeId: null,
                    geoNodeType: '',
                    iata: '',
                    itemLevel: '',
                    matchType: '',
                    name: '',
                    numRelatedLocations: null,
                    region: '',
                    text: '',
                    type: '',
                },
                destination: {
                    city: '',
                    country: '',
                    countryCode: '',
                    geoNodeId: null,
                    geoNodeType: '',
                    iata: '',
                    itemLevel: '',
                    matchType: '',
                    name: '',
                    numRelatedLocations: null,
                    region: '',
                    text: '',
                    type: '',
                },
            },
            {
                dateStr: '',
                departure: {
                    city: '',
                    country: '',
                    countryCode: '',
                    geoNodeId: null,
                    geoNodeType: '',
                    iata: '',
                    itemLevel: '',
                    matchType: '',
                    name: '',
                    numRelatedLocations: null,
                    region: '',
                    text: '',
                    type: '',
                },
                destination: {
                    city: '',
                    country: '',
                    countryCode: '',
                    geoNodeId: null,
                    geoNodeType: '',
                    iata: '',
                    itemLevel: '',
                    matchType: '',
                    name: '',
                    numRelatedLocations: null,
                    region: '',
                    text: '',
                    type: '',
                },
            },
        ],
        type: 'roundTrip',
    });
};
